import LoginPage from '../components/Login/Login';

export default function Login() {
  return <LoginPage />;
}
